import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { KETQUABAOVECAPVIEN_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import moment from 'moment';

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <span className="text-muted small">Không có file</span>
                )}
            </div>
        </Form.Group>
    );
};

const FieldDisplay = ({ label, value }) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div>
                <span className="text-dark" style={{ fontSize: '15px', fontWeight: 600 }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </span>
            </div>
        </Form.Group>
    );
};

const KetQuaBaoVeCapVienForm = ({ baoVeCapVienId, readOnly = false, isUserView = false, hoSoId, onDataLoaded, onSaveSuccess }) => {
    const [saving, setSaving] = useState(false);
    
    const [ketQuaBaoVeId, setKetQuaBaoVeId] = useState(null);
    const [isBienBanHop, setIsBienBanHop] = useState(true);
    const [isGhiChuDayDu, setIsGhiChuDayDu] = useState(true);
    const [isDuChuKy, setIsDuChuKy] = useState(true);
    const [ngayHop, setNgayHop] = useState('');
    const [fileMinhChungBienBan, setFileMinhChungBienBan] = useState('');
    const [soTanThanh, setSoTanThanh] = useState('');
    const [isDongGopMoi, setIsDongGopMoi] = useState(true);
    const [isTinCay, setIsTinCay] = useState(true);
    const [isYNghiaLyLuan, setIsYNghiaLyLuan] = useState(true);
    const [isThieuSot, setIsThieuSot] = useState(true);
    const [isDapUng, setIsDapUng] = useState(true);
    const [isBoSung, setIsBoSung] = useState(true);
    const [isKienNghi, setIsKienNghi] = useState(true);
    const [isKetQuaBieuQuyet, setIsKetQuaBieuQuyet] = useState(true);
    const [fileMinhChungHoiDong, setFileMinhChungHoiDong] = useState('');

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['ketQuaBaoVeCapVienData', baoVeCapVienId], 
        () => Get(`${KETQUABAOVECAPVIEN_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setKetQuaBaoVeId(item.id);
                setIsBienBanHop(item.isBienBanHop !== false);
                setIsGhiChuDayDu(item.isGhiChuDayDu !== false);
                setIsDuChuKy(item.isDuChuKy !== false);
                setNgayHop(item.ngayHop ? moment(item.ngayHop).format('YYYY-MM-DD') : '');
                setFileMinhChungBienBan(item.fileMinhChungBienBan || '');
                setSoTanThanh(item.soTanThanh || '');
                setIsDongGopMoi(item.isDongGopMoi !== false);
                setIsTinCay(item.isTinCay !== false);
                setIsYNghiaLyLuan(item.isYNghiaLyLuan !== false);
                setIsThieuSot(item.isThieuSot !== false);
                setIsDapUng(item.isDapUng !== false);
                setIsBoSung(item.isBoSung !== false);
                setIsKienNghi(item.isKienNghi !== false);
                setIsKetQuaBieuQuyet(item.isKetQuaBieuQuyet !== false);
                setFileMinhChungHoiDong(item.fileMinhChungHoiDong || '');
                
                if (onDataLoaded) onDataLoaded(true);
            } else {
                if (onDataLoaded) onDataLoaded(false);
            }
        } else if (queryRes === null) {
            if (onDataLoaded) onDataLoaded(false);
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                IsBienBanHop: isBienBanHop,
                IsGhiChuDayDu: isGhiChuDayDu,
                IsDuChuKy: isDuChuKy,
                NgayHop: ngayHop || null,
                FileMinhChungBienBan: fileMinhChungBienBan || '',
                SoTanThanh: soTanThanh ? parseInt(soTanThanh) : null,
                IsDongGopMoi: isDongGopMoi,
                IsTinCay: isTinCay,
                IsYNghiaLyLuan: isYNghiaLyLuan,
                IsThieuSot: isThieuSot,
                IsDapUng: isDapUng,
                IsBoSung: isBoSung,
                IsKienNghi: isKienNghi,
                IsKetQuaBieuQuyet: isKetQuaBieuQuyet,
                FileMinhChungHoiDong: fileMinhChungHoiDong || ''
            };

            if (ketQuaBaoVeId) {
                await Put(KETQUABAOVECAPVIEN_API.UPDATE_ITEM, ketQuaBaoVeId, { ...payload, Id: ketQuaBaoVeId });
            } else {
                await Post(KETQUABAOVECAPVIEN_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
            if (onSaveSuccess) onSaveSuccess();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Biên bản họp</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Biên bản họp</>} value={isBienBanHop ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Biên bản họp</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBienBanHop"
                                            checked={isBienBanHop === true}
                                            onChange={() => setIsBienBanHop(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBienBanHop"
                                            checked={isBienBanHop === false}
                                            onChange={() => setIsBienBanHop(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Biên bản họp ghi đầy đủ toàn bộ diễn biến của phiên họp</>} value={isGhiChuDayDu ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Biên bản họp ghi đầy đủ toàn bộ diễn biến của phiên họp</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isGhiChuDayDu"
                                            checked={isGhiChuDayDu === true}
                                            onChange={() => setIsGhiChuDayDu(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isGhiChuDayDu"
                                            checked={isGhiChuDayDu === false}
                                            onChange={() => setIsGhiChuDayDu(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Biên bản họp đủ chữ ký của Chủ tịch và Thư ký</>} value={isDuChuKy ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Biên bản họp đủ chữ ký của Chủ tịch và Thư ký</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDuChuKy"
                                            checked={isDuChuKy === true}
                                            onChange={() => setIsDuChuKy(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDuChuKy"
                                            checked={isDuChuKy === false}
                                            onChange={() => setIsDuChuKy(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">4.</span> Ngày họp</>} value={ngayHop ? moment(ngayHop).format('DD/MM/YYYY') : ''} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Ngày họp</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ngayHop}
                                        onChange={(e) => setNgayHop(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplayFile label={<><span className="text-danger">5.</span> File minh chứng</>} value={fileMinhChungBienBan} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle={<><span className="text-danger">5.</span> File minh chứng</>}
                                        value={fileMinhChungBienBan}
                                        onChangeProp={(url) => setFileMinhChungBienBan(url)}
                                        readOnly={readOnly || isUserView}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Nghị quyết của Hội đồng về luận án</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Kết quả bỏ phiếu của Hội đồng trong nghị quyết</>} value={soTanThanh} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Kết quả bỏ phiếu của Hội đồng trong nghị quyết</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soTanThanh}
                                        onChange={(e) => setSoTanThanh(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số phiếu tán thành..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Có nêu kết luận khoa học cơ bản, những điểm mới, đóng góp mới của luận án?</>} value={isDongGopMoi ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Có nêu kết luận khoa học cơ bản, những điểm mới, đóng góp mới của luận án?</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDongGopMoi"
                                            checked={isDongGopMoi === true}
                                            onChange={() => setIsDongGopMoi(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDongGopMoi"
                                            checked={isDongGopMoi === false}
                                            onChange={() => setIsDongGopMoi(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Có ghi cơ sở khoa học, độ tin cậy và những luận điểm và những kết luận của luận án?</>} value={isTinCay ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Có ghi cơ sở khoa học, độ tin cậy và những luận điểm và những kết luận của luận án?</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isTinCay"
                                            checked={isTinCay === true}
                                            onChange={() => setIsTinCay(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isTinCay"
                                            checked={isTinCay === false}
                                            onChange={() => setIsTinCay(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">4.</span> Có nêu ý nghĩa về lý luận, thực tiễn và những đề nghị sử dụng các kết quả nghiên cứu của luận án?</>} value={isYNghiaLyLuan ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Có nêu ý nghĩa về lý luận, thực tiễn và những đề nghị sử dụng các kết quả nghiên cứu của luận án?</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isYNghiaLyLuan"
                                            checked={isYNghiaLyLuan === true}
                                            onChange={() => setIsYNghiaLyLuan(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isYNghiaLyLuan"
                                            checked={isYNghiaLyLuan === false}
                                            onChange={() => setIsYNghiaLyLuan(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">5.</span> Những thiếu sót về nội dung và hình thức của luận án?</>} value={isThieuSot ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">5.</span> Những thiếu sót về nội dung và hình thức của luận án?</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isThieuSot"
                                            checked={isThieuSot === true}
                                            onChange={() => setIsThieuSot(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isThieuSot"
                                            checked={isThieuSot === false}
                                            onChange={() => setIsThieuSot(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">6.</span> Có nêu mức độ đáp ứng các yêu cầu của luận án?</>} value={isDapUng ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">6.</span> Có nêu mức độ đáp ứng các yêu cầu của luận án?</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDapUng"
                                            checked={isDapUng === true}
                                            onChange={() => setIsDapUng(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDapUng"
                                            checked={isDapUng === false}
                                            onChange={() => setIsDapUng(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">7.</span> Những điểm cần bổ sung, sửa chữa trước khi nộp luận án cho Thư viện Quốc gia Việt Nam</>} value={isBoSung ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">7.</span> Những điểm cần bổ sung, sửa chữa trước khi nộp luận án cho Thư viện Quốc gia Việt Nam</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBoSung"
                                            checked={isBoSung === true}
                                            onChange={() => setIsBoSung(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBoSung"
                                            checked={isBoSung === false}
                                            onChange={() => setIsBoSung(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">8.</span> Có nêu kiến nghị của Hội đồng về việc công nhận trình độ và cấp bằng tiến sĩ cho nghiên cứu sinh:</>} value={isKienNghi ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">8.</span> Có nêu kiến nghị của Hội đồng về việc công nhận trình độ và cấp bằng tiến sĩ cho nghiên cứu sinh:</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isKienNghi"
                                            checked={isKienNghi === true}
                                            onChange={() => setIsKienNghi(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isKienNghi"
                                            checked={isKienNghi === false}
                                            onChange={() => setIsKienNghi(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">9.</span> Có ghi kết quả biểu quyết công khai thông qua nghị quyết:</>} value={isKetQuaBieuQuyet ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">9.</span> Có ghi kết quả biểu quyết công khai thông qua nghị quyết:</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isKetQuaBieuQuyet"
                                            checked={isKetQuaBieuQuyet === true}
                                            onChange={() => setIsKetQuaBieuQuyet(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isKetQuaBieuQuyet"
                                            checked={isKetQuaBieuQuyet === false}
                                            onChange={() => setIsKetQuaBieuQuyet(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplayFile label={<><span className="text-danger">10.</span> File minh chứng</>} value={fileMinhChungHoiDong} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle={<><span className="text-danger">10.</span> File minh chứng</>}
                                        value={fileMinhChungHoiDong}
                                        onChangeProp={(url) => setFileMinhChungHoiDong(url)}
                                        readOnly={readOnly || isUserView}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default KetQuaBaoVeCapVienForm;
